import React, { useState, useEffect } from 'react';
import { Card, Form, Input, Space, Button, Cascader, message ,Modal} from 'antd';
import { useSupplierEntry } from '../../../hooks/supplier-entry';
import { _GLOBAL } from '../../../consts';
import SPFormatCash from '../../base/SPFormatCash'
import { debounce } from 'lodash';


const { SHOW_CHILD } = Cascader;
const { confirm } = Modal;
interface props {
  supplierInfo?: any
  refresh?: any
  enums?: any
  nextStep?: any
  preStep?:any
}

const SPDepositPayment: React.FC<props> = (props) => {
  const { supplierInfo } = props
  const [mainForm] = Form.useForm();

  const [cityList,setCityList] = useState<any>()
  const { getCityList,operationScaleSave,supplierEnter } = useSupplierEntry();

  const handelSupplierStoreCityEchoDisplay = (data: any, cityList: any) => {
    let arr:any = []
    data.map((item: any) => {
      cityList.map((city: any) => {
        if (item == city.code) {
          arr.push([city.code])
        } else {
          city.child.map((item2: any) => {
            if (item == item2.code) {
              arr.push([city.code, item2.code])
            }
          })
        }
      })
    })
    return arr
  }

  const handelSupplierCityEchoDisplay = (data:any, cityList: any) => {
    let arr: any = []
    cityList.map((item: any) => {
      if (data == item.code) {
        arr.push(item.code)
      } else {
        item.child.map((item2: any) => {
          if (data == item2.code) {
            arr.push(item.code, item2.code)
          }
        })
      }
    })
    return arr
  }

  const handelSupplierStoreCityChange = (data:any) => {
      let arr: any = []
      data?.map((item: any) => {
        if (item.length == 1) {
          arr.push(item[0].toString())
        } else {
          arr.push(item[1].toString())
        }
      })
    return arr
  }

  const onPaidAlready = debounce(() => {
    supplierEnter().then((res: any) => {
      mainForm.setFieldValue('amount_paid', res.data.amount_paid)
      if (res.data.amount_payable <= res.data.amount_paid) {
        confirm({
          title: false,
          icon: false,
          content: (<div style={{display:'flex',justifyContent:'center',alignItems:'center',flexDirection:'column'}}>
            <img src='https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/statusIcon.png' style={{width: '72px',height: '72px'}} alt=""/>
            <div style={{fontFamily:'PingFang SC',fontSize:'20px',color:'#1F1F1F',fontWeight:'500',lineHeight:'28px',marginTop:'32px'}}>入驻成功!</div>
            <div style={{fontFamily:'PingFang SC',fontSize:'14px',color:'#1F1F1F',fontWeight:'400',lineHeight:'22px',marginTop:'16px'}}>恭喜您入驻成功，即将为您更换新角色，角色更换后需重新登录，请您等待系统操作</div>
          </div>),
          cancelButtonProps: { style: { display: 'none' } },
          okButtonProps: { style: { display: 'none' } },
          closable:false,
        });
      } else {
        message.warning('入驻失败，账户余额不足，请确认账户金额是否充足')
      }
    })
  }, 2000, {
    leading: true, // 在调用时立即执行函数
    trailing: false // 防止在等待时间后再次执行函数
  })

  const onOperationScaleSave = () => {
    let params: any = {};
    if (mainForm.getFieldValue('supplier_city_id') == undefined) {
      message.warning('请先选择公司总部所在城市')
      return
    }
    params.supplier_city_id = mainForm.getFieldValue('supplier_city_id')[1].toString() || ''
    params.supplier_store_city_ids = handelSupplierStoreCityChange(mainForm.getFieldValue('supplier_store_city_ids')) || []
    if (params?.supplier_store_city_ids?.length > 0) {
      operationScaleSave(params).then((res) => {
        message.success('保存成功');
        mainForm.setFieldValue('amount_payable', res.data.amount_payable)
        mainForm.setFieldValue('need_paid', res.data.amount_payable - supplierInfo.amount_paid < 0 ? 0 : res.data.amount_payable - supplierInfo.amount_paid)
      }).catch((err) => {
        message.error(err.errmsg || '保存失败');
      })
    } else {
      message.error('请选择城市');
    }
  }

  useEffect(() => {
    getCityList().then((res) => {
      setCityList(res.data)
      mainForm.setFieldsValue(supplierInfo)
      mainForm.setFieldValue('need_paid', supplierInfo.amount_payable - supplierInfo.amount_paid < 0 ? 0 : supplierInfo.amount_payable - supplierInfo.amount_paid )
      mainForm.setFieldValue('supplier_city_id', handelSupplierCityEchoDisplay(supplierInfo.city_id || '', res.data || []) || [])
      mainForm.setFieldValue('supplier_store_city_ids', handelSupplierStoreCityEchoDisplay(supplierInfo.store_city_ids || [], res.data || []) || [])
    })
  }, []);

    return (
      < >
        <Card title={
          <div>
            <span>保证金缴纳</span>
            <span style={{ fontSize: 12, color: 'rgb(255, 100, 0)', marginLeft: 10 }}>请根据流程完成保证金缴纳，如您充值后界面末响应可手动点击我已缴纳</span>
          </div>
        } bodyStyle={{display:'flex',justifyContent:'center',flexWrap:'wrap'}}>
          <Form labelCol={{ style: { width: '130px' } }} style={{width:500}} form={mainForm}>
            <Form.Item
              label="企业名称"
              rules={[{ required: true }]}
              name="supplier_name"
            >
              <Input disabled></Input>
            </Form.Item>
            <Form.Item
              label="公司总部所在城市"
              rules={[{ required: true }]}
              name="supplier_city_id"
            >
              <Cascader
                  fieldNames={{ label: 'name', value: 'code', children: 'child' }}
                  // onChange={(value:any)=> mainForm.setFieldValue('supplier_city_id', value[0])}
                  style={{ width: '100%' }}
                  options={cityList}
                  showCheckedStrategy={SHOW_CHILD}
              />
            </Form.Item>
            <Form.Item
              label="门店覆盖城市"
              rules={[{ required: true }]}
              name="supplier_store_city_ids"
            >
              <Cascader
                  fieldNames={{ label: 'name', value: 'code', children: 'child' }}
                  // onChange={(value:any)=> handelSupplierStoreCityChange(value)}
                  onChange={() => onOperationScaleSave()}
                  // onClear={() => onOperationScaleSave()}
                  style={{ width: '100%' }}
                  options={cityList}
                  multiple
                  showCheckedStrategy={SHOW_CHILD}
              />
            </Form.Item>
            <Form.Item
              label="企业商户号"
              rules={[{ required: true }]}
              name="out_merchant_id"
            >
              <Input disabled></Input>
            </Form.Item>
            <Form.Item
              label="保证金所需金额"
              rules={[{ required: true }]}
              name="amount_payable"
            >
              <SPFormatCash disabled={true}></SPFormatCash>
            </Form.Item>
            <Form.Item
              label="滴滴账户余额"
              rules={[{ required: true }]}
              name="amount_paid"
            >
              <SPFormatCash disabled={true}></SPFormatCash>
            </Form.Item>
            <Space align="baseline">
              <Form.Item
                label="还需缴纳金额"
                rules={[{ required: true }]}
                name="need_paid"
              >
                <SPFormatCash disabled={true}></SPFormatCash>
              </Form.Item>
              <a href="https://s.didi-trip.com/yks-prod/image/zuche-sass-pc/helpPay.pdf"  target="_blank">如何缴纳?</a>
            </Space>
          </Form>
          <Space style={{width:'100%',display:'flex',justifyContent:'center',flexDirection:'column'}}>
            <Button type='primary' onClick={onPaidAlready}>我已缴纳</Button>
            {/* <Button type='primary' onClick={onOperationScaleSave}>保存信息</Button> */}
            <span style={{ fontSize: 12, color: 'rgb(255, 100, 0)', marginTop: 10 }}>余额入账有一定时效性，如打款后未查询到您可晚点在点击哦!</span>
          </Space>
        </Card>
      </>
    )
}

export default SPDepositPayment
